<template>
  <div>
    <h3 class="title-page">Reindex</h3>
    <div class="admin_container">
      <div class="text-right mb-3">
        <v-btn :loading="loading" @click="reIndexAll" color="primary"
          >Reindex all</v-btn
        >
      </div>
      <table-with-filter
        :is-filterable="false"
        fixed-header
        :height="$vuetify.breakpoint.height - 160"
        hide-default-footer
        :headers="headers"
        :items="items"
      >
        <template #item.action="{ item }">
          <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
            <template v-slot:activator="{ on }">
              <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
              <v-btn
                v-on="on"
                @click="reIndex(item)"
                :loading="item.loading"
                class="btn_33 new_plus_btn"
              >
                <vue-icon icon="indexIcon" :width="15" :height="15"></vue-icon>
              </v-btn>
            </template>
            <span>{{ $t("reindex") }}</span>
          </v-tooltip>
        </template>
      </table-with-filter>
    </div>
  </div>
</template>

<script>
import TableWithFilter from "@/components/ui/table/TableWithFilter";

export default {
  name: "reindex",
  components: { TableWithFilter },
  data() {
    return {
      items: [
        {
          reindexName: "reset-cache",
          loading: false,
          api: "backend/reset-cache",
        },
        {
          reindexName: "attribute",
          loading: false,
          api: "reindex/attribute",
        },
        {
          reindexName: "column-settings",
          loading: false,
          api: "reindex/column-settings",
        },
        {
          reindexName: "contract",
          loading: false,
          api: "reindex/contract",
        },
        {
          reindexName: "electronic-signature",
          loading: false,
          api: "reindex/electronic-signature",
        },
        {
          reindexName: "inventarization",
          loading: false,
          api: "reindex/inventarization",
        },
        {
          reindexName: "order",
          loading: false,
          api: "reindex/order",
        },
        {
          reindexName: "outgoing-contract",
          loading: false,
          api: "reindex/outgoing-contract",
        },
        {
          reindexName: "package",
          loading: false,
          api: "reindex/package",
        },
        {
          reindexName: "product",
          loading: false,
          api: "reindex/product",
        },
        {
          reindexName: "realization",
          loading: false,
          api: "reindex/realization",
        },
        {
          reindexName: "role-permission",
          loading: false,
          api: "reindex/role-permission",
        },
        {
          reindexName: "state",
          loading: false,
          api: "reindex/state",
        },
        {
          reindexName: "supplier",
          loading: false,
          api: "reindex/supplier",
        },
        {
          reindexName: "unit-type",
          loading: false,
          api: "reindex/unit-type",
        },
        {
          reindexName: "warehouse",
          loading: false,
          api: "reindex/warehouse",
        },
        {
          reindexName: "notification",
          loading: false,
          api: "reindex/notification",
        },
      ],
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("name"), value: "reindexName" },
        { text: this.$t("action"), value: "action" },
      ];
    },
  },
  methods: {
    reIndex(item) {
      item.loading = true;
      return this.$http
        .get(item.api, {
          timeout: 1000 * 60 * 3,
        })
        .then(() => {
          this.setSuccess({ text: this.$t("successMessages.reIndexed") });
        })
        .finally(() => {
          item.loading = false;
        });
    },
    reIndexAll() {
      this.items.reduce((acc, item) => {
        return acc
          .then(() => this.reIndex(item))
          .catch(() => this.reIndex(item));
      }, Promise.resolve());
    },
  },
};
</script>

<style scoped></style>
